import React from 'react';
import { createPortal } from 'react-dom';
import { IItem } from '../../slices/inventorySlice';
import { ItemInfo } from './ItemInfo';
import './ItemDetails.css';

export function ItemDetails({ item, onClose }: { item: IItem; onClose: () => void }) {
  return createPortal(<div className="item-details-overlay" onClick={onClose}>
    <section className="item-details-dialog" role="dialog" aria-modal="true" aria-label="รายละเอียดไอเท็ม" onClick={e=>e.stopPropagation()}>
      <header><strong>รายละเอียดไอเท็ม</strong><button type="button" onClick={onClose} aria-label="ปิดรายละเอียด">✕</button></header>
      <div className="item-details-body"><ItemInfo item={item} inline style={{width:'100%'}} /></div>
      <button className="item-details-close" type="button" onClick={onClose}>ปิด</button>
    </section>
  </div>, document.body);
}
